import { kvVeId } from "./id";

export function createEmptyTextContent(html = "") {
  return {
    tiptapJson: html,
  };
}

export function createBlock(type, settings = {}) {
  return {
    id: kvVeId("block"),
    type,
    settings: {
      // Block margins (spacing) - controlled per block
      // Defaults: top=8px, right/left=0px, bottom=0px
      marginTop: 4,
      marginRight: 0,
      marginBottom: 4,
      marginLeft: 0,
      ...settings,
    },
  };
}

export function createRow({ kind = "custom", columns = 1, settings = {}, preset = null } = {}) {
  const cols = Array.from({ length: columns }, () => ({
    id: kvVeId("col"),
    blocks: [],
  }));

  return {
    id: kvVeId("row"),
    kind,
    preset,
    settings: {
      backgroundColor: null,
      // Row padding is applied to each column content area.
      paddingTop: 8,
      paddingBottom: 8,
      paddingLeft: 8,
      paddingRight: 8,
      columnGap: 16,
      // Column width weights (e.g. [1,2] means 33% / 67%)
      columnWeights: Array.from({ length: columns }, () => 1),
      ...settings,
    },
    columns: cols,
  };
}

export function createContainer({ kind = "custom", title = "Container", settings = {}, rows = [] } = {}) {
  return {
    id: kvVeId("container"),
    kind,
    title,
    settings: {
      backgroundColor: null,
      contentBackgroundColor: null,
      contentBorderColor: null,
      contentBorderWidth: 0,
      contentBorderStyle: "none", // none | solid | dashed
      contentBorderRadius: 0,
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      ...settings,
    },
    rows,
  };
}

export function createDefaultEmailDoc() {
  const doc = {
    version: 2,
    body: {
      backgroundColor: "#f3f4f6",
      contentBackgroundColor: "#ffffff",
      width: 600,
      borderRadius: 8,
      topSpacing: 16,
      fontFamily: "Helvetica, Arial, sans-serif",
      textColor: "#111827",
      linkColor: "#0ea5e9",
      buttonBackgroundColor: "#111827",
      buttonTextColor: "#ffffff",
      mobilePadding: 16,
    },
    containers: [],
  };

  // Header: logo + title
  const row1 = createRow({ columns: 1, settings: { paddingTop: 24, paddingBottom: 8 } });
  row1.columns[0].blocks.push(
    createBlock("image", {
      src: "",
      alt: "Logo",
      href: "",
      align: "center",
      maxWidth: 80,
    }),
  );
  row1.columns[0].blocks.push(
    createBlock("text", {
      align: "center",
      content: {
        tiptapJson: {
          type: "doc",
          content: [
            {
              type: "paragraph",
              content: [
                {
                  type: "text",
                  text: "É hora de criar seu e-mail",
                  marks: [
                    {
                      type: "textStyle",
                      attrs: {
                        fontSize: "32px",
                        lineHeight: "1.2",
                        fontWeight: "700",
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: "paragraph",
              content: [
                {
                  type: "text",
                  text: "Você pode definir o layout do seu e-mail e dar um lugar para seu conteúdo adicionando, reorganizando e excluindo blocos de conteúdo.",
                },
              ],
            },
          ],
        },
      },
    }),
  );

  // Divider
  const row2 = createRow({ columns: 1, settings: { paddingTop: 8, paddingBottom: 8 } });
  row2.columns[0].blocks.push(createBlock("divider", { color: "#111827", thickness: 2 }));


  // Footer spacer
  const row4 = createRow({ columns: 1, settings: { paddingTop: 8, paddingBottom: 24 } });
  row4.columns[0].blocks.push(createBlock("spacer", { height: 16 }));
  row4.columns[0].blocks.push(
    createBlock("text", {
      align: "center",
      content: {
        tiptapJson: {
          type: "doc",
          content: [
            {
              type: "paragraph",
              content: [
                {
                  type: "text",
                  text: "Você recebeu este e-mail porque está inscrito.",
                  marks: [
                    {
                      type: "textStyle",
                      attrs: {
                        fontSize: "12px",
                        lineHeight: "1.4",
                        color: "#6b7280",
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: "paragraph",
              content: [
                {
                  type: "text",
                  text: "Descadastrar",
                  marks: [
                    {
                      type: "link",
                      attrs: {
                        href: "[[cliente.url_descadastro]]",
                        target: "_blank",
                      },
                    },
                    {
                      type: "textStyle",
                      attrs: {
                        fontSize: "12px",
                        lineHeight: "1.4",
                        color: "#6b7280",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      },
    }),
  );

  const header = createContainer({ kind: "header", title: "Header", rows: [row1] });
  const body = createContainer({ kind: "body", title: "Body", rows: [row2] });
  const footer = createContainer({ kind: "footer", title: "Footer", rows: [row4] });
  doc.containers = [header, body, footer];
  return doc;
}

export function createBlankEmailDoc() {
  return createDefaultEmailDoc();
}


